var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8620_833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8620_833",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 0H0V54H54V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8620_833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9424 46.8869C22.9142 46.8869 21.0432 46.2943 17.7986 43.924C15.7338 46.5906 9.23486 48.6645 8.94964 45.1091C8.94964 42.4457 8.35369 40.2012 7.69753 37.73C6.89392 34.7034 6 31.3366 6 26.4434C6 14.7751 15.5328 6 26.8355 6C38.1382 6 47 15.2036 47 26.5568C47 37.9099 37.8561 46.8869 26.9424 46.8869ZM27.1065 16.0873C21.6064 15.7978 17.3142 19.629 16.3677 25.6255C15.5839 30.5914 16.9735 36.6424 18.1623 36.9469C18.7224 37.0904 20.158 35.9244 21.0429 35.0356C22.4983 35.983 24.1685 36.7169 26.0251 36.8146C31.6717 37.1119 36.6757 32.6756 36.9714 27.0068C37.2672 21.338 32.7532 16.3845 27.1065 16.0873Z",
    fill: "url(#paint0_radial_8620_833)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8620_833",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8758 55.2342) scale(73.5048 75.9966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201923,
    stopColor: "#8D28C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384615,
    stopColor: "#7C42FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778846,
    stopColor: "#609CEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8620_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.418edc528b82ab87f636b2c19590a75d.svg";
export { ForwardRef as ReactComponent };